import React from 'react';
import Icon from '../../../components/AppIcon';

const ExpansionOverviewStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Overall Completion',
      value: `${stats?.overallCompletion}%`,
      icon: 'Target',
      color: 'var(--color-success)',
      trend: '+12% this week'
    },
    {
      label: 'Active Characters',
      value: stats?.activeCharacters,
      icon: 'Users',
      color: 'var(--color-primary)',
      trend: `${stats?.totalCharacters} total`
    },
    {
      label: 'Content Areas',
      value: stats?.contentAreas,
      icon: 'Map',
      color: 'var(--color-accent)',
      trend: `${stats?.completedAreas} completed`
    },
    {
      label: 'Trending Content',
      value: stats?.trendingContent,
      icon: 'TrendingUp',
      color: 'var(--color-warning)',
      trend: 'Most active this week'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
      {statCards?.map((stat, index) => (
        <div 
          key={index}
          className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-warm hover:shadow-warm-md transition-base"
        >
          <div className="flex items-start justify-between mb-3">
            <div 
              className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${stat?.color}20` }}
            >
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
          </div>
          <div className="space-y-1">
            <p className="text-xs md:text-sm text-muted-foreground">{stat?.label}</p>
            <p className="text-2xl md:text-3xl font-bold text-foreground">{stat?.value}</p>
            <p className="text-xs text-muted-foreground">{stat?.trend}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExpansionOverviewStats;